<template>
  <div class="home--inner">
    Home page
  </div>
</template>

<script>
export default {
  name: 'home',

  data () {
    return {
      newsList: []
    }
  }
}
</script>
